export const MOBILE_MAIN_CONTAINER_NAMES = {
  BACKGROUND: 'BACKGROUND',
  WHEEL: 'WHEEL',
  GAMEPAD: 'GAMEPAD',
  ODD_CRYSTALS: 'ODD_CRYSTALS',
  BONUS_BOARD_CONTAINER: 'BONUS_BOARD_CONTAINER',
  SCREEN_CHANGE_ANIMATION: 'SCREEN_CHANGE_ANIMATION',
  BUY_BONUS_POPUP: 'BUY_BONUS_POPUP',
  BIG_WIN_ANIMATION: 'BIG_WIN_ANIMATION',
  CONGRATULATIONS_BONUS_POPUP: 'CONGRATULATIONS_BONUS_POPUP',
};

export const MOBILE_PRE_BONUS_CONTAINER_NAMES = {
  BACKGROUND: 'BACKGROUND',
  GAMEPAD: 'GAMEPAD',
  SCREEN_CHANGE_ANIMATION: 'SCREEN_CHANGE_ANIMATION',
  PRE_BONUS_ANIMATION: 'PRE_BONUS_ANIMATION',
};

export const MOBILE_BONUS_CONTAINER_NAMES = {
  BACKGROUND: 'MOBILE_BONUS_CONTAINER_NAMES_BACKGROUND',
  WHEEL: 'MOBILE_BONUS_CONTAINER_NAMES_WHEEL',
  GAMEPAD: 'MOBILE_BONUS_CONTAINER_NAMES_GAMEPAD',
  SCREEN_CHANGE_ANIMATION: 'MOBILE_BONUS_CONTAINER_NAMES_SCREEN_CHANGE_ANIMATION',
  BONUS_PAD: 'MOBILE_BONUS_CONTAINER_NAMES_BONUS_PAD',
  CONGRATULATIONS_BONUS_POPUP: 'CONGRATULATIONS_MOBILE_BONUS_POPUP',
  BIG_WIN_ANIMATION: 'BIG_WIN_ANIMATION',
  GAME_PAD_FULL: 'GAME_PAD_FULL',
};
